/* =====================================================================
   UUGI v4 — Forms
   Custom AJAX submit + client-side validation for the four site forms:
   Contact, Suggest a Topic, Education Request and the footer Newsletter.
   Each handler no-ops when its form is absent, so this is safe to load on
   every page.
   Styling lives in css/components/forms.css.
   ===================================================================== */

$(function () {

  // Standard, pragmatic email pattern (mirrors [EmailAddress] on the server).
  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Posts the form and always resolves to { ok, data } — a non-JSON body
  // (e.g. an error page) comes back as an empty object rather than throwing.
  function postForm($form, form) {
    return fetch($form.attr('action'), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (res) {
      return res.json()
        .catch(function () { return {}; })
        .then(function (data) { return { ok: res.ok, data: data }; });
    });
  }

  // Swaps a submit button's label while keeping its arrow/icon intact.
  function labeller($btn) {
    var $label = $btn.find('.btn__label');
    return function (t) { if ($label.length) { $label.text(t); } else { $btn.text(t); } };
  }
  function labelOf($btn) {
    var $label = $btn.find('.btn__label');
    return $label.length ? $label.text() : $btn.text();
  }

  /* ---------- Panel forms (Contact + Suggest a Topic + Education) ----------
     All render the same .field / .field-error markup inside a glass panel and
     differ only in their ids, rules and thank-you copy. */
  function bindPanelForm(opts) {
    var $form = $(opts.form);
    if (!$form.length) { return; }

    var $error = $(opts.error);

    function fieldParts(name) {
      var $err = $form.find('.field-error[data-field="' + name + '"]');
      return { $err: $err, $input: $err.closest('.field').find('input, textarea') };
    }
    function showFieldError(name, message) {
      var p = fieldParts(name);
      p.$err.text(message).removeAttr('hidden');
      p.$input.addClass('is-invalid').attr('aria-invalid', 'true');
    }
    function clearFieldError(name) {
      var p = fieldParts(name);
      p.$err.text('').attr('hidden', true);
      p.$input.removeClass('is-invalid').removeAttr('aria-invalid');
    }
    function clearAll() {
      $error.attr('hidden', true).text('');
      $form.find('.field-error').each(function () { clearFieldError($(this).data('field')); });
    }

    // Live: clear a field's error as the user corrects it.
    $form.on('input', 'input, textarea', function () {
      var name = $(this).attr('name');
      if (name) { clearFieldError(name); }
      if (!$form.find('.field-error:not([hidden])').length) { $error.attr('hidden', true).text(''); }
    });

    $form.on('submit', function (e) {
      e.preventDefault();
      var form = this;
      var $btn = $form.find('button[type="submit"]');
      var origLabel = labelOf($btn);
      var setLabel = labeller($btn);

      var fail = function (message) {
        if (message) { $error.text(message).removeAttr('hidden'); }
        $btn.prop('disabled', false);
        setLabel(origLabel);
      };

      // ---- client-side validation ----
      clearAll();
      var firstInvalid = null;
      opts.rules.forEach(function (r) {
        var val = ($(r.sel).val() || '').trim();
        var msg = '';
        if (!val) { msg = r.required; }
        else if (r.email && !emailRe.test(val)) { msg = r.email; }
        // Optional per-rule regex (e.g. digits-only phone); mirrors a [RegularExpression] on the model.
        else if (r.pattern && !r.pattern.test(val)) { msg = r.patternMsg; }
        if (msg) { showFieldError(r.name, msg); if (!firstInvalid) { firstInvalid = r.sel; } }
      });
      if (firstInvalid) { $(firstInvalid).trigger('focus'); return; }

      // ---- submit ----
      $btn.prop('disabled', true);
      setLabel('Sending…');

      postForm($form, form)
        .then(function (result) {
          if (result.ok && result.data && result.data.success) {
            $(opts.thankYouHeading).text(result.data.thankYouHeading || opts.defaultHeading);
            $(opts.thankYouMessage).html(result.data.thankYouMessage || '');
            $form.attr('hidden', true);
            $(opts.thankYou).removeAttr('hidden');
            return;
          }
          // Map server-side (ModelState) errors back to their fields.
          if (result.data && result.data.errors) {
            var mappedAny = false, firstServer = null;
            Object.keys(result.data.errors).forEach(function (key) {
              var msgs = result.data.errors[key];
              var text = (msgs && msgs.join) ? msgs.join(' ') : String(msgs);
              if (fieldParts(key).$err.length) {
                showFieldError(key, text);
                mappedAny = true;
                if (!firstServer) { firstServer = fieldParts(key).$input; }
              }
            });
            if (firstServer) { firstServer.trigger('focus'); }
            fail(mappedAny ? '' : 'Please check the form and try again.');
            return;
          }
          fail('Something went wrong. Please try again.');
        })
        .catch(function () { fail('Network error. Please try again.'); });
    });
  }

  /* ---------- Contact form ---------- */
  bindPanelForm({
    form: '#contactForm',
    error: '#cf-error',
    // Required fields only — Organisation is intentionally optional.
    rules: [
      { name: 'Name', sel: '#cf-name', required: 'Please enter your name.' },
      { name: 'Email', sel: '#cf-email', required: 'Please enter your email.', email: 'Please enter a valid email address.' },
      { name: 'Message', sel: '#cf-msg', required: 'Please enter a message.' }
    ],
    thankYou: '#contactThankYou',
    thankYouHeading: '#cf-ty-heading',
    thankYouMessage: '#cf-ty-message',
    defaultHeading: 'Thank you!'
  });

  /* ---------- Suggest a Topic form ---------- */
  bindPanelForm({
    // #suggestTopicForm (not #suggestForm): the prototype umbrashow.js handler binds
    // #suggestForm, so the real form uses a distinct id to avoid a double submit.
    form: '#suggestTopicForm',
    error: '#sg-error',
    rules: [
      { name: 'Name', sel: '#sg-name', required: 'Please enter your name.' },
      { name: 'Email', sel: '#sg-email', required: 'Please enter your email.', email: 'Please enter a valid email address.' },
      { name: 'Topic', sel: '#sg-topic', required: 'Please enter a topic.' },
      { name: 'Description', sel: '#sg-desc', required: 'Please enter a short description.' }
    ],
    thankYou: '#suggestThankYou',
    thankYouHeading: '#sg-ty-heading',
    thankYouMessage: '#sg-ty-message',
    defaultHeading: 'Thanks for the idea!'
  });

  /* ---------- Education program request form ---------- */
  bindPanelForm({
    // #educationRequestForm (not #eduForm): the prototype education-program.js handler binds
    // #eduForm, so the real form uses a distinct id to avoid a double submit.
    form: '#educationRequestForm',
    error: '#ed-error',
    // Required fields only — City is intentionally optional.
    rules: [
      { name: 'Institution', sel: '#ed-inst', required: 'Please enter your institution name.' },
      { name: 'ContactPerson', sel: '#ed-person', required: 'Please enter a contact person.' },
      { name: 'Email', sel: '#ed-email', required: 'Please enter your email.', email: 'Please enter a valid email address.' },
      { name: 'Phone', sel: '#ed-phone', required: 'Please enter a phone number.', pattern: /^\d+$/, patternMsg: 'Please enter numbers only.' },
      { name: 'Message', sel: '#ed-msg', required: 'Please enter a message.' }
    ],
    thankYou: '#educationThankYou',
    thankYouHeading: '#ed-ty-heading',
    thankYouMessage: '#ed-ty-message',
    defaultHeading: 'Thanks for reaching out!'
  });

  // Phone is digits-only: strip anything else as it's typed or pasted, so the pattern rule above is
  // a backstop rather than something the user normally trips. Caret only jumps when input was rejected.
  $('#ed-phone').on('input', function () {
    var digits = this.value.replace(/\D/g, '');
    if (this.value !== digits) { this.value = digits; }
  });

  /* ---------- Newsletter block ----------
     Single field, and the error/thank-you sit outside the form element, so this
     keeps its own handler rather than reusing bindPanelForm. */
  (function () {
    var $form = $('#newsletterForm');
    if (!$form.length) { return; }

    var $section = $form.closest('.fv2-news');
    var $err = $form.siblings('#nf-email-err');

    function showError(message) {
      $err.text(message).removeAttr('hidden');
      $('#nf-email').addClass('is-invalid').attr('aria-invalid', 'true');
    }
    function clearError() {
      $err.text('').attr('hidden', true);
      $('#nf-email').removeClass('is-invalid').removeAttr('aria-invalid');
    }

    $form.on('input', 'input', clearError);

    $form.on('submit', function (e) {
      e.preventDefault();
      var form = this;
      var $btn = $form.find('button[type="submit"]');
      var origLabel = labelOf($btn);
      var setLabel = labeller($btn);

      clearError();
      var val = ($('#nf-email').val() || '').trim();
      if (!val) { showError('Please enter your email.'); $('#nf-email').trigger('focus'); return; }
      if (!emailRe.test(val)) { showError('Please enter a valid email address.'); $('#nf-email').trigger('focus'); return; }

      $btn.prop('disabled', true);
      setLabel('Subscribing…');

      postForm($form, form)
        .then(function (result) {
          if (result.ok && result.data && result.data.success) {
            $('#nf-ty-heading').text(result.data.thankYouHeading || 'You’re subscribed!');
            $('#nf-ty-message').html(result.data.thankYouMessage || '');
            $form.attr('hidden', true);
            $section.find('.fv2-news__copy').attr('hidden', true);
            $('#newsletterThankYou').removeAttr('hidden');
            return;
          }
          if (result.data && result.data.errors && result.data.errors.Email) {
            var msgs = result.data.errors.Email;
            showError((msgs && msgs.join) ? msgs.join(' ') : String(msgs));
          } else {
            showError('Something went wrong. Please try again.');
          }
          $btn.prop('disabled', false);
          setLabel(origLabel);
        })
        .catch(function () {
          showError('Network error. Please try again.');
          $btn.prop('disabled', false);
          setLabel(origLabel);
        });
    });
  })();

});
